"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _actions = require("../../../redux/sponsors/actions");

var _selectors = require("../../../redux/sponsors/selectors");

require("./index.css");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Sponsors = function Sponsors(_ref) {
  var label = _ref.label;
  var sponsors = (0, _selectors.useSponsorsSelector)();
  var dispatch = (0, _reactRedux.useDispatch)();
  (0, _react.useEffect)(function () {
    dispatch((0, _actions.loadSponsors)());
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return /*#__PURE__*/_react.default.createElement("div", {
    className: "flex sponsors-container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "sponsors-label bodyFont"
  }, label), /*#__PURE__*/_react.default.createElement("div", {
    className: "flex sponsors-logos marginLeft20"
  }, sponsors && sponsors.map(function (sponsor, index) {
    return /*#__PURE__*/_react.default.createElement("div", {
      key: "sponsor-".concat(index),
      className: "marginRight10"
    }, /*#__PURE__*/_react.default.createElement("a", {
      href: sponsor.url,
      target: "_blank",
      rel: "noopener noreferrer"
    }, /*#__PURE__*/_react.default.createElement("img", {
      src: sponsor.img,
      alt: sponsor.name,
      className: "sponsor-img"
    })));
  })));
};

Sponsors.defaultProps = {
  label: "NICA Locator Sponsored by:"
};
var _default = Sponsors;
exports.default = _default;